import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import App from "./App";
import "./index.css";

Amplify.configure(awsExports);

// ── DEV-ONLY isolated preview mount (never in production builds) ──────────
// /intake-preview renders the standalone ModernIntakeForm sandbox WITHOUT the
// authenticated app shell so it can be visually tested in the browser. The
// NODE_ENV check is compile-time (webpack DefinePlugin): in production builds
// this branch is dead code and the route falls through to the normal app,
// whose router redirects unknown paths. No live route or component changes.
if (
  process.env.NODE_ENV === "development" &&
  window.location.pathname === "/intake-preview"
) {
  const IntakePreviewPage = React.lazy(() => import("./pages/IntakePreviewPage"));
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <IntakePreviewPage />
      </React.Suspense>
    </React.StrictMode>
  );
} else if (
  process.env.NODE_ENV === "development" &&
  window.location.pathname === "/soc-preview"
) {
  // Same dev-only pattern: SOC Dashboard v2 with a stubbed auth session so
  // it can be compared against the spec without a Cognito login.
  const SocPreviewPage = React.lazy(() => import("./pages/SocPreviewPage"));
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <SocPreviewPage />
      </React.Suspense>
    </React.StrictMode>
  );
} else if (
  process.env.NODE_ENV === "development" &&
  window.location.pathname === "/command-center-v2-preview"
) {
  // Same dev-only pattern: Command Center v2 (role comes from its in-page
  // switcher, so no auth stub is needed). /api/command-center/* is served by
  // an in-memory stand-in so the SWR store has something to talk to.
  const CommandCenterV2Page = React.lazy(() =>
    import("./pages/command-center-v2/preview-api").then(({ installCommandCenterPreviewApi }) => {
      installCommandCenterPreviewApi();
      return import("./pages/CommandCenterV2Page");
    })
  );
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <BrowserRouter>
          <CommandCenterV2Page />
        </BrowserRouter>
      </React.Suspense>
    </React.StrictMode>
  );
} else if (
  process.env.NODE_ENV === "development" &&
  window.location.pathname === "/performance-v2-preview"
) {
  // Same dev-only pattern: Performance Review v2 under a stubbed auth session
  // (?role=owner|technician|…); page data is the spec's mock constants.
  const PerformanceV2PreviewPage = React.lazy(() => import("./pages/PerformanceV2PreviewPage"));
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <PerformanceV2PreviewPage />
      </React.Suspense>
    </React.StrictMode>
  );
} else {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode><App /></React.StrictMode>
  );
}
